import { render, staticRenderFns } from "./ViewStatus.vue?vue&type=template&id=2bc5e9ca&scoped=true&"
import script from "./ViewStatus.vue?vue&type=script&lang=js&"
export * from "./ViewStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc5e9ca",
  null
  
)

export default component.exports